import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DialogService } from '../shared/services/decativateDialog/dialog.service';

@Component({
  selector: 'lib1-base-url-change-dialog',
  templateUrl: './base-url-change-dialog.component.html',
  styleUrls: ['./base-url-change-dialog.component.scss'],
})

//FOR REF:
//https://www.digitalocean.com/community/tutorials/angular-component-inheritance
export class BaseUrlChangeDialogComponent {

  //showDialog = false;
  subject = new Subject<boolean>();

  constructor(public dialogService: DialogService) {

    this.listenToResponseFromDialog();

  }

  listenToResponseFromDialog() {

    this.dialogService.responseFromDialogAsObservable.subscribe((shouldLeavePageAndGoToNextPage: boolean) => {


      if (shouldLeavePageAndGoToNextPage && shouldLeavePageAndGoToNextPage != null) {

        this.onSelection('ok');

      } else {

        this.onSelection('NotOk');

      }

    });

  }

  onSelection($event: any) {

    //console.log($event);

    //this.showDialog = false;

    if ($event === 'ok') {

      this.subject.next(true);

    } else {

      this.subject.next(false);

    }

  }

  //is called from confirmation guard 
  openDialog() {

    //console.log('opn dialog');
    //this.showDialog = true;

    this.dialogService.setShowDialogSubject(true);
  }

}
